module.exports = __webpack_public_path__ + "img/logo-assynco.8097ecba.svg";